var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 7.66667H14.6667M6.66667 10.3333H10.6667M2 11.6756C2 13.0978 2.99822 14.3369 4.40622 14.544C5.40978 14.6916 6.424 14.8044 7.44889 14.8809C7.76 14.904 8.04444 15.0676 8.21778 15.3262L10.6667 19L13.1156 15.3262C13.2015 15.1985 13.3154 15.092 13.4486 15.0148C13.5818 14.9376 13.7309 14.8918 13.8844 14.8809C14.9024 14.8049 15.9172 14.6925 16.9271 14.544C18.3351 14.3369 19.3333 13.0987 19.3333 11.6747V6.32534C19.3333 4.90134 18.3351 3.66311 16.9271 3.456C14.8542 3.15175 12.7618 2.99934 10.6667 3C8.54044 3 6.44978 3.15556 4.40622 3.456C2.99822 3.66311 2 4.90222 2 6.32534V11.6747V11.6756Z",
    stroke: "#798CAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.b759d4b568aa9c7568dd82125cb16742.svg";
export { ForwardRef as ReactComponent };